/* eslint-disable */
import { parseUnits } from '@ethersproject/units'
import {
  ButtonMenu,
  ButtonMenuItem,
  CloseIcon,
  Heading,
  IconButton,
  InjectedModalProps,
  ModalBody,
  ModalContainer,
  ModalTitle,
  useMatchBreakpoints,
  Text,
  useModal,
} from '@noahswap/uikit'
import { useWeb3React } from '@noahswap/wagmi'
import { useEffect, useState, useMemo } from 'react'
import { BigNumber, BigNumberish } from '@ethersproject/bignumber'
import { useVoterContract } from 'hooks/useContract'
import { useTranslation } from '@noahswap/localization'
import styled from 'styled-components'
import { ListLogo } from 'components/Logo'
import { ChainLogo } from 'components/Logo/ChainLogo'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import styles from '../style/all.module.scss'
import { Span } from '@sentry/nextjs'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`

const SelectBtn = styled.div`
  display: flex;
  padding: 19px;
  font-size: 20px;
  border: 1px solid #eeeeee;
  border-radius: 6px;
  margin-bottom: 10px;
  cursor: pointer;

  &.active {
    border-color: #000;
    background: #ffe169;
  }
`

const VoteModal: React.FC<React.PropsWithChildren<any>> = ({ onDismiss, voteList, handleGoVote }) => {
  const { isMobile } = useMatchBreakpoints()
  const { account } = useWeb3React()
  const { t } = useTranslation()
  // console.log('arr', voteList)

  const handleVote = async () => {
    // 告诉父组件要执行handleGoVote事件了
    handleGoVote()
  }
  return (
    <ModalContainer
      title={t('noah182')}
      $minWidth={isMobile ? '100%' : '418px'}
      $minHeight={'auto'}
      style={{ width: '300px' }}
    >
      <ModalHeader>
        <ModalTitle>
          <Heading>{t('noah368')}</Heading>
        </ModalTitle>
        <IconButton variant="text" onClick={onDismiss}>
          <CloseIcon width="24px" color="#000" />
        </IconButton>
      </ModalHeader>
      <ModalBody p="0 24px 24px 24px" width="100%">
        <div className={`${styles.tips}`}>{t(`noah422`)}</div>
        <div className={`${styles.list2}`}>
          <div className={`${styles.tit} flexb`}>
            <span>{t('noah286')} </span>
            <span>{t('noah363')}</span>
          </div>
          <div className={styles.box}>
            {voteList?.votedItems.length > 0 ? (
              voteList.votedItems.map((item, index) => {
                const symbolChange = {
                  token0: {
                    name: item.name0,
                    symbol: item.symbol0,
                    address: item.contract0,
                  },
                  token1: {
                    name: item.name1,
                    symbol: item.symbol1,
                    address: item.contract1,
                  },
                }
                return (
                  <div key={index}>
                    {voteList.votes[item.id] && (
                      <div className={`${styles.item} flexb`}>
                        <div className={`${styles.one} flex flexc flexstart`}>
                          {/* <ListLogo logoURI={item.img0} size="21px" />
                          <ListLogo logoURI={item.img1} size="21px" style={{ position: 'relative', left: '-6px' }} /> */}
                          <DoubleCurrencyLogo token0={symbolChange.token0} token1={symbolChange.token1} size={25} />
                          <div className={`flex flexc`} style={{ marginLeft: '20px' }}>
                            <div className={`${styles.symbol0Name}`}>
                              {item.symbol0}
                              <span className={`${styles.symbol1Name}`}>/{item.symbol1}</span>
                            </div>
                          </div>
                        </div>
                        <div className={styles.rate}>{voteList.votes[item.id]}%</div>
                      </div>
                    )}
                  </div>
                )
              })
            ) : (
              <div className="no_data">
                <img src="/images/claim/nodata.png" alt="" style={{ width: '70px', height: '50px' }} />
                {/* 您的投票奖励为空 */}
                <Text fontSize="18px" color="#85868A" mb="20px" mt="12px">
                  {t('noah338')}
                </Text>
              </div>
            )}
            {/* {voteList.votedItems.map((item, index) => (
              <div className={`${styles.item} flexb`} key={index}>
                <div className={`${styles.one} flex flexc flexstart`}>
                  <ListLogo logoURI={item.img0} size="21px" />
                  <ListLogo logoURI={item.img1} size="21px" style={{ position: 'relative', left: '-6px' }} />
                  <div className={`flex flexc`}>
                    <div className={`${styles.symbol0Name}`}>
                      {item.symbol0}
                      <span className={`${styles.symbol1Name}`}>/{item.symbol1}</span>
                    </div>
                  </div>
                </div>
                <div className={styles.rate}>{voteList.votes[item.id]}%</div>
              </div>
            ))} */}
          </div>
        </div>

        <div className={styles.details}>
          {t(`noah365`)}: {voteList.totalVotes}%
        </div>
        {/* 确认投票 */}
        <div
          className={styles.btn}
          onClick={() => {
            handleVote()
          }}
        >
          {t('noah368')}
        </div>
      </ModalBody>
    </ModalContainer>
  )
}

export default VoteModal
